import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const ITextFileService = ( createDecorator('textFileService'));
export { ITextFileService };
